/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class QueryAssistApi {
  async LoadFromQueryString(query : string) : Promise<st.QueryPreview> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'LoadFromQueryString', {
      query,
    });
  }
  async LoadFromQueryXML(queryXml : string) : Promise<st.QueryPreview> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'LoadFromQueryXML', {
      queryXml,
    });
  }
  async Prompt(prompt : string, currentQuery : string) : Promise<st.QueryPreview> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'Prompt', {
      prompt,
      currentQuery,
    });
  }
  async GetSources(prompt : string, kbOverride : string) : Promise<Array<st.QueryAssistReference>> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'GetSources', {
      prompt,
      kbOverride,
    });
  }
  async SetUserRating(aiLogGU : string, isHelpful : boolean) : Promise<any> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'SetUserRating', {
      aiLogGU,
      isHelpful,
    });
  }
  async GetQueryString(preview : st.QueryPreview) : Promise<string> {
    return await componentApi.call('st', 'st-query-assist', 'QueryAssistApi', 'GetQueryString', {
      preview,
    });
  }
}
export default new QueryAssistApi()
